export default "__VITE_ASSET__BloL7QIR__"